// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class WalkerSitterAPI extends MainAPI {
	
	async putWalkerSitterDetails(walkerSitterDetails) {
		let newFormData = new FormData();

		const {formData, userImage} = walkerSitterDetails;
		
		newFormData.append('formData', JSON.stringify(formData));
		
		if (formData.user.isImageChanged) {
			newFormData.append('profileImage', userImage);
		}
		return API.put(`${ENDPOINTS.PUT_WALKER_SITTER}`, newFormData);
	}

	/**
	 * @return {object} walker sitter list
	 * @param {*} walkerSitterDetails - Contains pagination data
	 * @param petId - Pet's ID
	 */
	async getWalkerSitterList(walkerSitterDetails) {
		return API.get(`${ENDPOINTS.GET_WALKER_SITTER}?${queryString.stringify(walkerSitterDetails)}`);
	}

	/**
	 * @param {*} availabilityDetails
	*/
	async postWalkerSitterAvailability(availabilityDetails) {
		return API.post(`${ENDPOINTS.POST_WALKER_SITTER}/available-date`, availabilityDetails);
	}

	async saveToFavorite(bodyParams) {
		return API.post(`${ENDPOINTS.POST_WALKER_SITTER}/favorite`, bodyParams);
	}
}

export default new WalkerSitterAPI();